import { CancelTokenSource } from 'axios'
import { Option } from 'fp-ts/lib/Option'
import { v4 as uuid4 } from 'uuid'

import { AttachmentError } from './attachment-error'
export interface AttachmentMetadata {
  name: string
  path: string
  version: Option<string>
}

export type AttachmentModel =
  | ErroredAttachment
  | LoadingAttachment
  | UploadedAttachment
  | PublishedAttachment // in addition to having been uploaded to S3, also saved as part of published organisation

export class ErroredAttachment {
  public readonly kind = 'ErroredAttachment'
  constructor(
    readonly id: string,
    readonly attachment: AttachmentMetadata,
    readonly error: AttachmentError.Type
  ) {}
}

export class UploadedAttachment {
  public readonly kind = 'UploadedAttachment'
  constructor(
    readonly id: string,
    readonly attachment: AttachmentMetadata
  ) {}

  public static of = (x: AttachmentMetadata) =>
    new UploadedAttachment(uuid4(), x)
}

export class LoadingAttachment {
  public readonly kind = 'LoadingAttachment'
  constructor(
    readonly id: string,
    readonly attachment: AttachmentMetadata,
    readonly file: File,
    readonly cancelToken: CancelTokenSource,
    readonly progress: number
  ) {}
}

export class PublishedAttachment {
  public readonly kind = 'PublishedAttachment'
  constructor(
    readonly id: string,
    readonly name: string,
    readonly path: string,
    readonly attachment: AttachmentMetadata
  ) {}

  public static of = (x: AttachmentMetadata) =>
    new PublishedAttachment(uuid4(), x.name, x.path, x)
}
